import * as React from 'react'
import { connect } from 'react-redux'
import { models } from '../../store'
import { RematchDispatch, RematchRootState } from '@rematch/core'
import { IStation, WishType } from 'types'

interface GetCurrentLocationProps extends ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {}

interface StateProps {
  currentPosition: undefined | Position
}

class GetCurrentLocation extends React.Component<GetCurrentLocationProps, StateProps> {
  constructor(props: GetCurrentLocationProps) {
    super(props)
    this.state = {
      currentPosition: undefined,
    }
  }

  async componentDidMount() {
    if (this.props.currentLocation === undefined) {
      this.props.getCurrentLocation()
    }
  }
  render() {
    return <div />
  }
}

const mapStateToProps = (state: RematchRootState<models>) => ({
  currentLocation: state.wishes.currentLocation,
})

const mapDispatchToProps = (dispatch: RematchDispatch<models>) => {
  return {
    getCurrentLocation: () => dispatch.wishes.getCurrentLocation(),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GetCurrentLocation)



// WEBPACK FOOTER //
// ./src/components/location/GetCurrentLocation.tsx